import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector } from '@store';
import useReview from '@hooks/useReview';
import { CapaQuotationChatMessageRfq } from '@generated/graphql';
import { isClosedTypes } from '@components/Chat/types';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: '0px 16px 16px 16px'
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    },
    cta: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 16,
      '& .mb-10': {
        marginBottom: 10
      },
      '& .mb-24': {
        marginBottom: 24
      },
      '& .text': {
        ...theme.typography.body2,
        color: colorSet.gray700,
        textDecoration: 'underline'
      }
    }
  };
});

interface Props {
  chatMessage: CapaQuotationChatMessageRfq;
  profileId: string;
}

const ReviewRequestRegisterTransactionBubble: React.FC<Props> = ({
  chatMessage,
  profileId
}: Props) => {
  const classes = useStyles();
  const rfqId = useSelector((state) => state.chat.rfqId);
  const quotationPartnerId = useSelector(
    (state) => state.chat.quotationPartnerId
  );

  const partnerOrganizationName =
    chatMessage?.rfq?.partnerOrganizationName ?? '';
  const projectName = chatMessage?.rfq?.projectName ?? '';

  const hasReview = useSelector((state) => state.chat.hasReview ?? false);
  const chatRoomStatus = useSelector((state) => state.chat.chatRoomStatus);
  const isClosed = chatRoomStatus
    ? isClosedTypes.includes(chatRoomStatus)
    : false;

  const { onUpdateReview } = useReview();

  return (
    <Box className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          안내
        </CustomizedTypography>
      </div>
      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            고객님, 리뷰작성 요청이 도착했습니다.
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className={classes.wordBreak}>
            파트너가 제품 품질에 대한 리뷰작성을 요청했어요.
          </CustomizedTypography>
        </div>
      </div>

      <div className={classes.cta}>
        <CustomizedButton
          disabled={isClosed || hasReview}
          fullWidth
          variant="contained"
          color="primary"
          className="mb-10"
          onClick={() =>
            onUpdateReview({
              open: true,
              rfqId: rfqId ?? '',
              quotationPartnerId: quotationPartnerId ?? '',
              profileId: profileId,
              reviewId: '',
              projectName: projectName,
              organizationName: partnerOrganizationName
            })
          }
        >
          리뷰 작성하기
        </CustomizedButton>
      </div>
    </Box>
  );
};

export default ReviewRequestRegisterTransactionBubble;
